<template>
<div style="width:100%; height:100%; display:flex; align-items:center;">
  <div style="width:100%; display:flex; flex-direction:column;">
    <div style="width: 100%; display: flex; flex-direction: row; justify-content: center">
      <FulfillingBouncingCircleSpinner
        :animation-duration="4000"
        :size="90"
        color="#00838f"
      />
     </div>
    <div style="width: 100%; display: flex; flex-direction: row; justify-content: center">
      <div style="margin-top:56px; font-size: 20px; font-weight: bold;">
        Setting up your new project ...
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { FulfillingBouncingCircleSpinner } from 'epic-spinners'

export default {
  name: 'AddProjectLoader',
  components: {
    FulfillingBouncingCircleSpinner
  },
  timers: {
    finishLoading: {time: 3000, autostart: true}
  },
  methods: {
    finishLoading: function () {
      this.$emit('finish-loading')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AddProjectLoader.vue